import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./title-carousel.${locale}.json`));
